<div class="background">
    <h3 mat-dialog-title>Edit {{ data.field }} of {{ data.property }}: </h3>
    <form>
        <mat-form-field class="full-width">
            <mat-chip-grid #chipGrid aria-label="Enter Jira Id" >
            @for (keyword of values(); track keyword) {
                <mat-chip-row (removed)="remove(keyword)">
                    {{keyword}}
                    <button matChipRemove [attr.aria-label]="'remove ' + keyword">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            }
            </mat-chip-grid>
            <input style="margin-top: 10px" matInput
                placeholder="FWRAC2"
                [matChipInputFor]="chipGrid"
                (matChipInputTokenEnd)="add($event)"/>
            <mat-hint style="margin-top: 5px">Press 'Enter' to add your input to the list.</mat-hint>
        </mat-form-field>
    </form>

    <mat-card class="edited-card"
              [ngClass]="{'status-edited': (editedValue$ | async) === true,
              'status-failed': (editedValue$ | async) === false, 'status-not-edited': !editPressed}">
        <p *ngIf="!editPressed">Press Save to submit your change.</p>
        @if (editPressed) {
            <p *ngIf="(editedValue$ | async) === null">Editing...</p>
            <p *ngIf="(editedValue$ | async) === true">Your Change has been made.</p>
            <p *ngIf="(editedValue$ | async) === false">Your Change could not be made.</p>
        }
    </mat-card>

    <div [align]="'end'" mat-dialog-actions>
        <button [mat-dialog-close]="false" mat-raised-button>Cancel</button>
        <button (click)="editValue()" color="primary" mat-raised-button
                [disabled]="editPressed || areArraysEqual(values(), data.values)">Save
        </button>
    </div>
</div>
